import React, { useEffect } from 'react'
import { Wave } from 'react-animated-text';
import Slider from "react-slick";

import AOS from 'aos'
import 'aos/dist/aos.css'

import ps from '../images/icons/photoshop1.png'
import ai from '../images/icons/illustrator.png'
import pr from '../images/icons/premere.png'
import ae from '../images/icons/after effects2.png'
import sa from '../images/icons/substance.png'
import sh from '../images/icons/Silhouette .png'
import mo from '../images/icons/mocha pro.png'
import pf from '../images/icons/PF Track.png'
import bo from '../images/icons/Boujou.png'
import bl from '../images/icons/blender2.png'
import ma from '../images/icons/maya.png'
import nu from '../images/icons/nuke.png'
import un from '../images/icons/unreal engine.png'
import ait from '../images/icons/ait.png'


import one1 from '../images/hi/one.png'
import two from '../images/hi/two.png'
import three from '../images/hi/three.png'
import four from '../images/hi/four.png'
import five from '../images/hi/five.png'
import six from '../images/hi/six.png'
import seven from '../images/hi/seven.png'



import background from '../images/banner/background.png'

//icons
import { GiComputerFan } from "react-icons/gi";
import { FaSquareXTwitter } from "react-icons/fa6";
import { BsInstagram } from "react-icons/bs";
import { FiFacebook } from "react-icons/fi";

import { SiCrowdsource } from "react-icons/si";
import { MdOutlineMenuBook } from "react-icons/md";
import { TbBrandAirtable } from "react-icons/tb";
import { SlEnergy } from "react-icons/sl";

import { MdLeaderboard } from "react-icons/md";
import { GiSpellBook } from "react-icons/gi";

import Mentors from '../components/Mentors';

//images
import video from '../images/banner/video.mp4'

import web from '../images/series.png'

import slideOne from '../images/Award.png'
import slideTwo from '../images/tuor.png'
import slideThree from '../images/create.png'
import slideFour from '../images/emi.png'

import success from '../images/high/success.png'
import Global from '../images/high/Global.png'
import indus from '../images/high/indus.png'
import handsOn from '../images/high/Hands.png'
import expert from '../images/high/Experts.png'

import highOne from '../images/h1.png'
import highTwo from '../images/h2.png'
import highThree from '../images/h3.png'
import highFour from '../images/h4.png'

import mentorOne from '../images/mentorOne.png'
import mentorTwo from '../images/mentorTwo.png'

import contact from '../images/Us.png'

import banner from '../images/banner/banner.jpg'

import CourseOne from '../components/CourseOne';
import CourseTwo from '../components/CourseTwo';
import Faq from '../components/Faq';
import Contact from '../components/Contact';
import one from '../images/one.jpg'


const Home = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 })
    }, [])


    const settings = {
        // dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 6000,
        cssEase: "linear"
    };

    const settingshigh = {
        className: "center",
        infinite: true,
        autoplay: true,
        slidesToScroll: 1,
        centerPadding: "60px",
        slidesToShow: 3,
        speed: 4000,
        autoplaySpeed: 2000,
        cssEase: "linear",
        swipeToSlide: true,
        afterChange: function (index) {
            console.log(`Slider Changed to: ${index + 1}, background: #222; color: #bada55`);
        },
        responsive: [
            {
                breakpoint: 2500,
                settings: {
                    slidesToShow: 4,
                    centerPadding: "30px",
                }
            },
            {
                breakpoint: 2000,
                settings: {
                    slidesToShow: 3,
                    centerPadding: "30px",
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                    centerPadding: "30px",
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    centerPadding: "30px",
                }
            },

            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    centerPadding: "20px",
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    centerPadding: "15px",
                }
            }
        ]
    };


    return (
        <>
            <div className='overflow-hidden'>

                <div className='w-full fixed top-0 -z-20 '>
                    <div className='relative'>

                        <img src={background} className='w-full h-screen' alt="" />
                        <div className='absolute inset-0 backdrop-blur-sm bg-teal-200/30 '></div>
                    </div>
                </div>

                <section>

                    <div>
                        {/* <img src={banner} className='w-full object-cover' alt="" /> */}
                        <video autoPlay loop muted playsInline className="w-full">
                            <source src={video} type="video/mp4" />
                        </video>
                    </div>
                </section>

                {/* <section className='bg-black/60  md:bg-black/85'>
                    <div className=' w-full px-1 md:w-[80%] pt-2 pb-2 md:pt-16 md:pb-16 mx-auto font-[poppins] ' data-aos='fade-left'>
                        <div className='flex  items-center'>

                            <div className='w-[40%] md:w-[60%] bg-gray-900 drop-shadow-lg shadow-md overflow-hidden h-[19rem] md:h-[31rem] rounded-l-md md:rounded-l-xl'>

                                <div className="slider-container ">
                                    <Slider {...settings} className='' >

                                        <div className=''>
                                            <img src={slideOne} className='object-cover w-full  h-[31rem] rounded-l-md md:rounded-l-xl ' alt="" />
                                        </div>

                                        <div>
                                            <img src={slideTwo} className='object-cover w-full  h-[31rem] rounded-l-md md:rounded-l-xl ' alt="" />
                                        </div>
                                        <div>
                                            <img src={slideThree} className='object-cover w-full  h-[31rem] rounded-l-md md:rounded-l-xl ' alt="" />
                                        </div>
                                        <div>
                                            <img src={slideFour} className='object-cover w-full  h-[31rem] rounded-l-md md:rounded-l-xl ' alt="" />
                                        </div>

                                    </Slider>
                                </div>
                            </div>


                            <div className='w-[60%] md:w-[40%] drop-shadow-lg shadow-md shadowgray-100 bg-gray-200 h-[19rem] md:h-[31rem] pt-6 pb-6 rounded-r-md md:rounded-r-xl'>

                                <div className=' -ml-6 md:-ml-12 flex flex-col gap-y-6'>
                                    <div className='flex items-center gap-x-2 md:gap-x-6' data-aos="fade-up" data-aos-delay="30" data-aos-duration="4000">

                                        <div className='h-12 w-12 md:h-24 md:w-24 backdrop-blur-sm bg-white/30 rounded-full '>
                                            <img src={highTwo} className='object-cover w-40 md:w-full' alt="" />
                                        </div>

                                        <div>
                                            <h3 className='font-bold text-gray-900 text-[10px] md:text-[16px]'>EMI Facilities</h3>
                                        </div>
                                    </div>
                                    <div className='flex items-center gap-x-2 md:gap-x-6' data-aos="fade-up" data-aos-delay="50" data-aos-duration="5000">

                                        <div className='h-12 w-12 md:h-24 md:w-24 backdrop-blur-sm bg-white/30 rounded-full '>
                                            <img src={highThree} className='object-cover w-40 md:w-full' alt="" />

                                        </div>

                                        <div>
                                            <h3 className='font-bold text-gray-900 text-[10px] md:text-[16px]'>Overseas Tour</h3>
                                        </div>
                                    </div>

                                    <div className='flex items-center gap-x-2 md:gap-x-6' data-aos="fade-up" data-aos-delay="70" data-aos-duration="6000" >

                                        <div className='h-12 w-12 md:h-24 md:w-24 backdrop-blur-sm bg-white/30 rounded-full '>
                                            <img src={highFour} className='object-cover w-40 md:w-full' alt="" />

                                        </div>

                                        <div>
                                            <h3 className='font-bold text-gray-900 text-[10px] md:text-[16px]'>Create webseries as part of curriculum </h3>
                                        </div>
                                    </div>

                                    <div className='flex items-center gap-x-2 md:gap-x-6' data-aos="fade-up" data-aos-delay="80" data-aos-duration="4000" >

                                        <div className='h-12 w-12 md:h-24 md:w-24 backdrop-blur-sm bg-white/30 rounded-full '>
                                            <img src={highOne} className='object-cover w-40 md:w-full' alt="" />

                                        </div>

                                        <div>
                                            <h3 className='font-bold text-gray-900 text-[10px] md:text-[16px]'>Award Winning Tutors</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>  */}

                <section className='bg-[#FAF9F6]  pt-16  md:pt-20 pb-10 md:pb-20 font-[poppins]'>
                    <div className='w-[80%] mx-auto'>


                        <div className='grid grid-cols-1 md:grid-cols-3 gap-y-10 gap-x-10'>

                            <div>

                                <div className='bg-white shadow-md drop-shadow-md shadow-gray-300  px-6 py-4 rounded-xl' data-aos="fade-up" data-aos-delay="30" data-aos-duration="1000">
                                    <div className='-mt-10 md:-mt-14 h-14 w-14 md:h-24 md:w-24 backdrop-blur-sm bg-white/30 rounded-full '>
                                        <img src={highTwo} className='object-cover w-44 md:w-full' alt="" />
                                    </div>

                                    <div className='flex justify-center mt-2 md:mt-0'>
                                        <h3 className='text-center font-bold text-gray-900 text-[12px] md:text-[16px] '>EMI Facilities</h3>
                                    </div>
                                </div>

                            </div>

                            <div>

                                <div className='bg-white shadow-md drop-shadow-md shadow-gray-300  px-6 py-4 rounded-xl' data-aos="fade-up" data-aos-delay="50" data-aos-duration="2000">
                                    <div className='-mt-10 md:-mt-14 h-14 w-14 md:h-24 md:w-24 backdrop-blur-sm bg-white/30 rounded-full '>
                                        <img src={highFour} className='object-cover w-44 md:w-full' alt="" />
                                    </div>

                                    <div className='flex justify-center mt-2 md:mt-0 '>
                                        <h3 className='text-center font-bold text-gray-900 text-[12px] md:text-[16px] '>Create webseries as part of curriculum</h3>
                                    </div>
                                </div>

                            </div>

                            <div>

                                <div className='bg-white shadow-md drop-shadow-md shadow-gray-300  px-6 py-4 rounded-xl' data-aos="fade-up" data-aos-delay="80" data-aos-duration="3000">
                                    <div className='-mt-10 md:-mt-14 h-14 w-14 md:h-24 md:w-24 backdrop-blur-sm bg-white/30 rounded-full '>
                                        <img src={highOne} className='object-cover w-44 md:w-full' alt="" />
                                    </div>

                                    <div className='flex justify-center mt-2 md:mt-0'>
                                        <h3 className='text-center font-bold text-gray-900 text-[12px] md:text-[16px] '>Award Winning Tutors</h3>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </section>


                {/* our advantages tour & web series */}

                <section className='font-[poppins]'>
                    <div class="pt-8 md:pt-20 pb-8 md:pb-20 inset-0 -z-10 h-full w-full bg-[#f9f9f9] bg-[linear-gradient(to_right,#f0f0f0_1px,transparent_1px),linear-gradient(to_bottom,#f0f0f0_1px,transparent_1px)] bg-[size:6rem_4rem]">
                        <div className='w-full px-4 md:w-[80%] mx-auto'>



                            <div className='flex flex-col gap-y-1 items-center justify-center ' data-aos='fade-up'>
                                <h3 className='uppercase font-semibold text-[12px] md:text-[22px] text-center text-gray-950 font-[roboto]'>Elevate Your Filmmaking with Cinema Factory </h3>
                                <h3 className='uppercase font-semibold text-[14px] md:text-[24px] text-center text-gray-950 md:tracking-[2px] '>Master Web Series Production and Overseas Shoots </h3>
                            </div>

                            <div className='mt-5 md:mt-16 flex flex-col gap-y-10 px-2 md:px-0'>

                                <div className='flex flex-col md:flex-row items-center gap-y-4 gap-x-16 font-[roboto]'>

                                    <div className=' w-full md:w-[50%] mx-auto flex justify-start' data-aos='fade-right'>

                                        <div>
                                            <img src={web} className='object-cover  w-full md:w-[85%] ' alt="" />
                                        </div>

                                    </div>

                                    <div className=' w-full md:w-[50%] mx-auto flex justify-center ' data-aos='fade-left'>

                                        <div>

                                            <div>
                                                {/* <h3 className='font-[poppins] uppercase font-semibold mb-4 text-center md:text-start text-[12px]  md:text-[14px] text-gray-950 px-3 md:px-0 '> <Wave text="Benefits of Shooting Web Series at Cinema Factory Film Academy" effect="stretch" effectChange={2.0} />  </h3> */}


                                                <div class="font-[poppins] uppercase font-semibold mb-4 text-center md:text-start text-[12px]  md:text-[15px] text-gray-950 px-3 md:px-0 ">
                                                    <span class="bg-clip-text text-transparent bg-gradient-to-r from-blue-900 via-orange-600 to-red-500">
                                                        Benefits of Shooting Web Series at Cinema Factory Film Academy
                                                    </span>
                                                </div>


                                            </div>

                                            <div className='flex flex-col gap-y-5'>

                                                <div>
                                                    <div className='flex items-center gap-x-2 mb-3 '>
                                                        <div>
                                                            <SiCrowdsource className='text-[16px] md:text-[20px] ' />
                                                        </div>
                                                        <h4 className='font-semibold text-[12px] md:text-[14px]'>Stand out from the crowd</h4>
                                                    </div>
                                                    <div className='flex flex-col gap-y-2'>
                                                        <p className='font-normal text-[11px] md:text-[12px] text-gray-900'>Explore the booming web series market to enhance storytelling skills, gain hands-on filmmaking experience, build your brand with on-screen credits, and foster creativity through collaborative team projects. </p>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div className='flex items-center gap-x-2 mb-3'>
                                                        <div>
                                                            <MdOutlineMenuBook className='text-[16px] md:text-[20px] ' />
                                                        </div>
                                                        <h4 className='font-semibold text-[12px] md:text-[14px]'>Learning by Doing</h4>
                                                    </div>
                                                    <div className='flex flex-col gap-y-2'>
                                                        <p className='font-normal text-[11px] md:text-[12px] text-gray-900'>Gain comprehensive filmmaking experience from pre-production to post-production, mastering effective budgeting under real-world constraints essential for future projects.</p>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div className='flex items-center gap-x-2 mb-3'>
                                                        <div>
                                                            <TbBrandAirtable className='text-[16px] md:text-[20px] ' />
                                                        </div>
                                                        <h4 className='font-semibold text-[12px] md:text-[14px]'>Building Your Brand</h4>
                                                    </div>
                                                    <div className='flex flex-col gap-y-2'>
                                                        <p className='font-normal text-[11px] md:text-[12px] text-gray-900'>Earn on-screen credits to establish your filmmaking identity and enrich your portfolio, gaining a competitive edge by graduating with a completed web series.</p>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div className='flex items-center gap-x-2 mb-3'>
                                                        <div>
                                                            <SlEnergy className='text-[16px] md:text-[20px] ' />
                                                        </div>
                                                        <h4 className='font-semibold text-[12px] md:text-[14px]'>Boosting Your Creativity</h4>
                                                    </div>
                                                    <div className='flex flex-col gap-y-2'>
                                                        <p className='font-normal text-[11px] md:text-[12px] text-gray-900'>Craft and execute multi-episode stories to expand creative boundaries within a collaborative environment, honing essential communication and teamwork skills for your film career.</p>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </section >


                {/* --------------- success section  -------------- */}

                <section className=' bg-gray-900 pt-14 md:pt-20 pb-20 font-[poppins]'>
                    <div className='px-4 w-full  md:w-[85%] mx-auto  '>

                        <div className='flex flex-col md:flex-row  justify-center items-center gap-x-20  gap-y-6'>

                            <div className='w-full md:w-[60%] mx-auto' data-aos='fade-right'>
                                <h3 className='font-bold uppercase text-white  text-[14px] md:text-[26px] text-center'>Discover success with our VFX & cg course</h3>
                                <p className='font-medium text-gray-50 text-center text-[10px] md:text-[14px] mt-2'>Our directors bring decades of experience. From indie gems to box office hits, they've done it all.</p>
                            </div>

                            <div className='w-full md:w-[40%] mx-auto' data-aos='fade-left'>
                                <div className='flex justify-center items-center'>
                                    <img src={success} className=' w-full md:w-[90%] object-cover rounded-md drop-shadow-lg  animate-pulse duration-500 delay-500 ' alt="" />
                                </div>
                            </div>

                        </div>

                    </div>

                    <div className='w-[80%] mx-auto mt-10 md:mt-20 '>

                        <div className='grid grid-cols-1 md:grid-cols-4 gap-y-6 gap-x-8'>

                            <div>
                                <div className='flex flex-col items-center gap-y-2' data-aos="fade-up" data-aos-delay="30" data-aos-duration="1000">
                                    <div className='w-full flex justify-center'>
                                        <img src={expert} className='object-cover w-20' alt="" />
                                    </div>

                                    <div className='flex flex-col justify-center items-center gap-y-2'>
                                        <h3 className='font-semibold text-[14px] md:text-[16px] text-white'>Expert Guidance</h3>
                                        <p className='text-center text-gray-200 text-[10px] md:text-[12px] font-[roboto]'>Learn from award-winning cinema experts with extensive industry experience and proven excellence.</p>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className='flex flex-col items-center gap-y-2' data-aos="fade-up" data-aos-delay="50" data-aos-duration="2000">

                                    <div className='w-full flex justify-center'>
                                        <img src={Global} className='object-cover w-20' alt="" />
                                    </div>

                                    <div className='flex flex-col justify-center items-center gap-y-2'>
                                        <h3 className='font-semibold text-[14px] md:text-[16px] text-white'>Global Exposure</h3>
                                        <p className='text-center text-gray-200 text-[10px] md:text-[12px] font-[roboto]'>Benefit from an international study trip, gaining valuable insights and perspectives from global cinema markets.</p>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className='flex flex-col items-center gap-y-2' data-aos="fade-up" data-aos-delay="80" data-aos-duration="3000">
                                    <div className='w-full flex justify-center'>
                                        <img src={handsOn} className='object-cover w-20' alt="" />
                                    </div>

                                    <div className='flex flex-col justify-center items-center gap-y-2'>
                                        <h3 className='font-semibold text-[14px] md:text-[16px] text-white'>Hands-on Experience</h3>
                                        <p className='text-center text-gray-200 text-[10px] md:text-[12px] font-[roboto]'>Participate in shooting a web series while studying, applying your skills in real-world projects.</p>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className='flex flex-col items-center gap-y-2' data-aos="fade-up" data-aos-delay="90" data-aos-duration="3000">
                                    <div className='w-full flex justify-center'>
                                        <img src={indus} className='object-cover w-20' alt="" />
                                    </div>

                                    <div className='flex flex-col justify-center items-center gap-y-2'>
                                        <h3 className='font-semibold text-[14px] md:text-[16px] text-white'>Industry Connections</h3>
                                        <p className='text-center text-gray-200 text-[10px] md:text-[12px] font-[roboto]'>Leverage our strong connections within the cinema industry for networking, internships, and career opportunities</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>



                {/* --------------------- programs ------------------------ */}

                <section className="relative bg-white  pt-7 md:pt-16 pb-4 px-4" id="course">

                    <div className="container w-full  flex flex-col justify-center items-center mx-auto ">


                        <h3 className="flex flex-col justify-center items-center w-full md:w-[60%] mx-auto">

                            <h3 variant="" className="uppercase mb-1 md:mb-3 font-bold text-[18px] sm:text-[20px] md:text-[24px]" color="blue-gray" data-aos='fade-up' data-aos-delay="50" data-aos-duration="1000">  Courses </h3>
                            <p className="text-[12px] sm:text-[14px] md:text-[16px] text-center mt-1 sm:mt-2 md:mt-3 font-normal text-blue-gray-500" data-aos='fade-up' data-aos-delay="80" data-aos-duration="2000">
                                Our program features acclaimed filmmaker tutors who are award-winners, providing invaluable expertise for aspiring directors.
                            </p>
                        </h3>


                        <div className="grid  grid-col-1 md:grid-cols-2 gap-x-1 w-full  ">

                            <div className="-mt-16 md:mt-0 " data-aos='fade-up' data-aos-duration="1000">
                                <CourseTwo />
                            </div>

                            <div className=" -mt-20 md:mt-0 " data-aos='fade-up' data-aos-duration="2000">
                                <CourseOne />
                            </div>

                        </div>

                    </div>

                </section>

                {/* ----------------------- course highlights ----------------- */}

                <section className="bg-[#fff7f7] pt-8 md:pt-20 pb-8 md:pb-20">
                    <div className=" w-full px-4 md:w-[90%] mx-auto font-[poppins]">

                        <div className="flex flex-col  justify-center items-center">
                            <h1 className="font-bold uppercase text-[16px] md:text-[22px] ">Course Highligts</h1>

                            <p className='font-nor text-[10px] sm:text-[12px] md:text-[14px] text-gray-800 mt-3 w-full md:w-[80%] text-center'>Master essential VFX techniques and industry-standard software to create stunning visual effects. Learn from expert instructors and build a professional portfolio to launch your career in the VFX industry.</p>
                        </div>


                        <div className="mt-6 md:mt-16">

                            <div className="slider-container">
                                <Slider {...settingshigh} className="px-3">

                                    {/* <div className="px-3 py-2 h-full">

                                        <div className="flex flex-col justify-center items-center gap-y-3 bg-white px-4 py-5 rounded-md hover:shadow-md hover:drop-shadow-lg h-32 md:h-40  ">

                                            <div>
                                                <img src={one1} className="object-cover w-16 md:w-20 drop-shadow-md hover:drop-shadow-lg" alt="" />
                                            </div>
                                            <div>
                                                <h3 className="text-[10px] md:text-[12px] text-center">Exclusive partnership with leading VFX company, Cine Vaults, offering industry expertise from Bollywood and international projects.</h3>
                                            </div>

                                        </div>
                                    </div> */}

                                    <div className="px-3 py-2 h-full">

                                        <div className="flex flex-col justify-center items-center gap-y-3 bg-white px-4 py-5 rounded-md hover:shadow-md hover:drop-shadow-lg h-32 md:h-40  ">

                                            <div>
                                                <img src={two} className="object-cover w-16 md:w-20 drop-shadow-md hover:drop-shadow-lg" alt="" />
                                            </div>
                                            <div>
                                                <h3 className="text-[10px] md:text-[12px] text-center">Updated VFX syllabus that includes the latest techniques and technologies.</h3>
                                            </div>

                                        </div>
                                    </div>




                                    <div className="px-3 py-2 h-full">
                                        <div className="flex flex-col justify-center items-center gap-y-3 bg-white px-4 py-5 rounded-md hover:shadow-md hover:drop-shadow-lg h-32 md:h-40  ">

                                            <div>
                                                <img src={three} className="object-cover w-16 md:w-20 drop-shadow-md hover:drop-shadow-lg" alt="" />
                                            </div>
                                            <div>
                                                <h3 className="text-[10px] md:text-[12px] text-center">Only film institute offering a VFX course with modern AI integration.</h3>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="px-3 py-2 h-full">
                                        <div className="flex flex-col justify-center items-center gap-y-3 bg-white px-4 py-5 rounded-md hover:shadow-md hover:drop-shadow-lg h-32 md:h-40  ">

                                            <div>
                                                <img src={four} className="object-cover w-16 md:w-20 drop-shadow-md hover:drop-shadow-lg" alt="" />
                                            </div>
                                            <div>
                                                <h3 className="text-[10px] md:text-[12px] text-center">Learn VFX in a film academy environment, providing a comprehensive understanding of filmmaking and storytelling.</h3>
                                            </div>

                                        </div>
                                    </div>


                                    <div className="px-3 py-2 h-full">
                                        <div className="flex flex-col justify-center items-center gap-y-3 bg-white px-4 py-5 rounded-md hover:shadow-md hover:drop-shadow-lg h-32 md:h-40  ">

                                            <div>
                                                <img src={five} className="object-cover w-16 md:w-20 drop-shadow-md hover:drop-shadow-lg" alt="" />
                                            </div>
                                            <div>
                                                <h3 className="text-[10px] md:text-[12px] text-center">Hands-on training on industry-standard software and tools.</h3>
                                            </div>

                                        </div>
                                    </div>


                                    <div className="px-3 py-2 h-full">

                                        <div className="flex flex-col justify-center items-center gap-y-3 bg-white px-4 py-5 rounded-md hover:shadow-md hover:drop-shadow-lg h-32 md:h-40  ">

                                            <div>
                                                <img src={six} className="object-cover w-16 md:w-20 drop-shadow-md hover:drop-shadow-lg" alt="" />
                                            </div>
                                            <div>
                                                <h3 className="text-[10px] md:text-[12px] text-center">Opportunity to work on real-world projects and collaborate with professionals in the field.</h3>
                                            </div>

                                        </div>
                                    </div>


                                    <div className="px-3 py-2 h-full">

                                        <div className="flex flex-col justify-center items-center gap-y-3 bg-white px-4 py-5 rounded-md hover:shadow-md hover:drop-shadow-lg h-32 md:h-40  ">

                                            <div>
                                                <img src={seven} className="object-cover w-16 md:w-20 drop-shadow-md hover:drop-shadow-lg" alt="" />
                                            </div>
                                            <div>
                                                <h3 className="text-[10px] md:text-[12px] text-center">Holistic learning approach that combines technical skills with artistic vision, preparing you for a successful career in VFX.</h3>
                                            </div>

                                        </div>
                                    </div>


                                </Slider>
                            </div>

                        </div>

                    </div>
                </section>





                {/* ------------------- vfx  softwares  -------------------- */}

                <section className=' pt-10 md:pt-20 pb-10 md:pb-20 bg-gray-900'>
                    <div className='w-full px-4 md:w-[80%] mx-auto font-[poppins]'>

                        <div className='flex justify-center items-center'>

                            <h2 className='font-semibold text-center text-[16px] sm:text-[18px] md:text-[30px] text-white uppercase'>Visual Effects - Softwares Covered</h2>

                        </div>

                        <div className=' mt-8 md:mt-20'>
                            <div className=' grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-x-4 md:gap-x-14 gap-y-8 md:gap-y-14'>

                                <div className='' data-aos='fade-up'>
                                    <div className='flex flex-col items-center gap-y-4 border border-dashed w-full  rounded-lg px-2 md:px-4 py-6'>

                                        <div>
                                            <img src={ps} className='w-12 md:w-16 object-cover hover:animate-spin cursor-pointer ' alt="" />
                                        </div>
                                        <div>
                                            <h1 className='text-gray-200 font-semibold   text-[11px] md:text-[12px]  uppercase'>Adobe Photoshop</h1>
                                        </div>

                                    </div>
                                </div>
                                <div className='' data-aos='fade-up'>
                                    <div className='flex flex-col items-center gap-y-4 border border-dashed  w-full  rounded-lg px-2 md:px-4 py-6'>

                                        <div>
                                            <img src={ai} className='w-12 md:w-16 object-cover hover:animate-spin cursor-pointer ' alt="" />
                                        </div>
                                        <div>
                                            <h1 className='text-gray-200 font-semibold   text-[11px] md:text-[12px]  uppercase'>Adobe Illustrator      </h1>
                                        </div>

                                    </div>
                                </div>
                                <div className='' data-aos='fade-up'>
                                    <div className='flex flex-col items-center gap-y-4 border border-dashed  w-full  rounded-lg px-2 md:px-4 py-6'>

                                        <div>
                                            <img src={pr} className='w-12 md:w-16 object-cover hover:animate-spin cursor-pointer ' alt="" />
                                        </div>
                                        <div>
                                            <h1 className='text-gray-200 font-semibold   text-[11px] md:text-[12px]  uppercase'>Adobe Premiere                                             </h1>
                                        </div>

                                    </div>
                                </div>
                                <div className='' data-aos='fade-up'>
                                    <div className='flex flex-col items-center gap-y-4 border border-dashed  w-full  rounded-lg px-2 md:px-4 py-6'>

                                        <div>
                                            <img src={ae} className='w-12 md:w-16 object-cover hover:animate-spin cursor-pointer ' alt="" />
                                        </div>
                                        <div>
                                            <h1 className='text-gray-200 font-semibold  text-[11px] md:text-[12px] uppercase'>Adobe After Effects                                            </h1>
                                        </div>

                                    </div>
                                </div>
                                <div className='' data-aos='fade-up'>
                                    <div className='flex flex-col items-center gap-y-4 border border-dashed  w-full  rounded-lg px-2 md:px-4 py-6'>

                                        <div>
                                            <img src={sa} className='w-12 md:w-16 object-cover hover:animate-spin cursor-pointer ' alt="" />
                                        </div>
                                        <div>
                                            <h1 className='text-gray-200 font-semibold  text-[11px] md:text-[12px]  uppercase'>Adobe Substance 3D                                             </h1>
                                        </div>

                                    </div>
                                </div>
                                <div className='' data-aos='fade-up'>
                                    <div className='flex flex-col items-center gap-y-4 border border-dashed  w-full  rounded-lg px-2 md:px-4 py-6'>

                                        <div>
                                            <img src={sh} className='w-12 md:w-16 object-cover hover:animate-spin cursor-pointer ' alt="" />
                                        </div>
                                        <div>
                                            <h1 className='text-gray-200 font-semibold   text-[11px] md:text-[12px]  uppercase'>Silhouette </h1>
                                        </div>

                                    </div>
                                </div>


                                <div className='' data-aos='fade-up'>
                                    <div className='flex flex-col items-center gap-y-4 border border-dashed  w-full  rounded-lg px-2 md:px-4 py-6'>

                                        <div>
                                            <img src={mo} className='w-12 md:w-16 object-cover hover:animate-spin cursor-pointer ' alt="" />
                                        </div>
                                        <div>
                                            <h1 className='text-gray-200 font-semibold  text-[11px] md:text-[12px]  uppercase'>Mocha Pro                                            </h1>
                                        </div>

                                    </div>
                                </div>


                                <div className='' data-aos='fade-up'>
                                    <div className='flex flex-col items-center gap-y-4 border border-dashed  w-full  rounded-lg px-2 md:px-4 py-6'>

                                        <div>
                                            <img src={pf} className='w-12 md:w-16 object-cover hover:animate-spin cursor-pointer ' alt="" />
                                        </div>
                                        <div>
                                            <h1 className='text-gray-200 font-semibold  text-[11px] md:text-[12px]  uppercase'>PF Track                                            </h1>
                                        </div>

                                    </div>
                                </div>


                                <div className='' data-aos='fade-up'>
                                    <div className='flex flex-col items-center gap-y-4 border border-dashed  w-full  rounded-lg px-2 md:px-4 py-6'>

                                        <div>
                                            <img src={bo} className='w-12 md:w-16 object-cover hover:animate-spin cursor-pointer ' alt="" />
                                        </div>
                                        <div>
                                            <h1 className='text-gray-200 font-semibold  text-[11px] md:text-[12px]  uppercase'>Boujou                                            </h1>
                                        </div>

                                    </div>
                                </div>
                                <div className='' data-aos='fade-up'>
                                    <div className='flex flex-col items-center gap-y-4 border border-dashed  w-full  rounded-lg px-2 md:px-4 py-6'>

                                        <div>
                                            <img src={bl} className='w-12 md:w-16 object-cover hover:animate-spin cursor-pointer ' alt="" />
                                        </div>
                                        <div>
                                            <h1 className='text-gray-200 font-semibold  text-[11px] md:text-[12px]  uppercase'>Blender</h1>
                                        </div>

                                    </div>
                                </div>
                                <div className='' data-aos='fade-up'>
                                    <div className='flex flex-col items-center gap-y-4 border border-dashed  w-full  rounded-lg px-2 md:px-4 py-6'>

                                        <div>
                                            <img src={ma} className='w-12 md:w-16 object-cover hover:animate-spin cursor-pointer ' alt="" />
                                        </div>
                                        <div>
                                            <h1 className='text-gray-200 font-semibold  text-[11px] md:text-[12px]  uppercase'>Maya                                            </h1>
                                        </div>

                                    </div>
                                </div>
                                <div className='' data-aos='fade-up'>
                                    <div className='flex flex-col items-center gap-y-4 border border-dashed  w-full  rounded-lg px-2 md:px-4 py-6'>

                                        <div>
                                            <img src={nu} className='w-12 md:w-16 object-cover hover:animate-spin cursor-pointer ' alt="" />
                                        </div>
                                        <div>
                                            <h1 className='text-gray-200 font-semibold  text-[11px] md:text-[12px]  uppercase'>Nuke                                            </h1>
                                        </div>

                                    </div>
                                </div>
                                <div className='' data-aos='fade-up'>
                                    <div className='flex flex-col items-center gap-y-4 border border-dashed  w-full  rounded-lg px-2 md:px-4 py-6'>

                                        <div>
                                            <img src={un} className='w-12 md:w-16 object-cover hover:animate-spin  cursor-pointer' alt="" />
                                        </div>
                                        <div>
                                            <h1 className='text-gray-200 font-semibold  text-[11px] md:text-[12px] uppercase'>Unreal Engine </h1>
                                        </div>

                                    </div>
                                </div>
                                <div className='' data-aos='fade-up'>
                                    <div className='flex flex-col items-center gap-y-4 border border-dashed  w-full  rounded-lg px-2 md:px-4 py-6'>

                                        <div>
                                            <img src={ait} className='w-12 md:w-16 object-cover hover:animate-spin cursor-pointer ' alt="" />
                                        </div>
                                        <div>
                                            <h1 className='text-gray-200 font-semibold  text-[11px] md:text-[12px]  uppercase'>AI Integrated Tools</h1>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </section>


                {/* ---------------------- mentors ----------------- */}

                <section>
                    <div>
                        <div class="bg-gray-50   py-9 md:py-20 font-[poppins]" id='mentors'>
                            <div class="container mx-auto px-4 md:px-12 xl:px-32">
                                <div class="mb-3 md:mb-16">
                                    <h2 class="uppercase mb-4 text-center font-bold text-gray-900  text-[16px] md:text-[24px]" data-aos='fade-up'>
                                        Our mentors
                                    </h2>
                                    <p class="text-gray-700  lg:mx-auto w-ful lg:w-8/12 text-center text-[12px] md:text-[14px]" data-aos='fade-up'>
                                        Learn from the masters of extensive expertise and proven excellence to guide and inspire our students in their cinematic pursuits.
                                    </p>
                                </div>

                                <div className='flex justify-center items-center w-full'>

                                    <Mentors />


                                </div>

                            </div>
                        </div>

                    </div>
                </section>


                {/* --------------------- accoriden -------------- */}

                <div className="bg-[#f5f5f5]">

                    <div className="container mx-auto ">
                        <div className=" py-8 md:py-16">
                            <Faq />
                        </div>
                    </div>

                </div>


                {/* --------------------------- contact  --------------- */}

                <section>
                    <div className='w-full mx-auto  font-[poppins]' id='contact'>

                        <div className='flex flex-col justify-center items-center gap-x-10  z-10 bg-[#f0eee4] pt-10 pb-10 '>

                            <div className='px-4 md:px-0 flex flex-col justify-center items-center mb-8' >
                                <h3 className='font-bold uppercase text-[18px] md:text-[28px] text-gray-900 '>Get in touch</h3>
                                <p className='text-gray-700 text-[10px] md:text-[14px] font-semibold w-full md:w-[80%] mt-2 md:mt-3 text-center'>Reach out to our team for any inquiries, application assistance, or additional information about our programs and benefits. </p>
                            </div>


                            <div className='px-4 w-full md:w-[80%]  mx-auto   z-10   md:mt-6 '>

                                <div className='flex  justify-center items-center'>

                                    <div className='flex flex-col-reverse md:flex-row items-center gap-x-16 gap-y-8'>

                                        <div className='w-full md:w-[50%]'>
                                            <Contact />
                                        </div>

                                        <div className='w-full md:w-[50%]  -mt-8 md:mt-0 '>
                                            <img src={contact} className='object-cover  drop-shadow-md' alt="" />
                                        </div>


                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* 
                        <div className='-mt-60 '>
                            <svg xmlns="http://www.w3.org/2000/svg" className='-z-20' viewBox="0 0 1440 320"><path fill="#0099ff" fill-opacity="1" d="M0,256L48,234.7C96,213,192,171,288,176C384,181,480,235,576,224C672,213,768,139,864,106.7C960,75,1056,85,1152,80C1248,75,1344,53,1392,42.7L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
                            <svg xmlns="http://www.w3.org/2000/svg" className='-z-20' viewBox="0 0 1440 320"><path fill="#ff5500" fill-opacity="1" d="M0,256L48,234.7C96,213,192,171,288,176C384,181,480,235,576,224C672,213,768,139,864,106.7C960,75,1056,85,1152,80C1248,75,1344,53,1392,42.7L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
                        </div> */}


                    </div>
                </section>

            </div>
        </>
    )
}

export default Home